<template>
  <div class="game-header">
    <div class="backarrowDiv" v-on:click="prevChapter">
      <inline-svg
        class="arrow-svg-game"
        :src="arrowIconPath.arrowIconPrevious"
      ></inline-svg>
    </div>
    <div class="game-titles">
      <h6>
        {{ currentData && currentData.courseName }}
        {{
          externalData ? externalData.name : $t("grammarGame.game-header.title")
        }}
      </h6>
      <h6 v-if="currentData">
        {{
          currentData ? currentData.name : $t("grammarGame.game-header.title")
        }}
      </h6>
    </div>

    <!-- <ProgressBar
      class="progress-bar-container"
      :progress="progress"
      :max="100"
    /> -->
  </div>
</template>

<script>
import "./game-header.scss";
import { getArrowIconPath } from "../../utils/svgConfig";
import { languageDirectionMapping } from "../../main";

export default {
  name: "GameHeader",
  props: ["currentData", "word", "WIN", "status", "externalData"],
  data() {
    return {
      lessonName: this.$t("grammarGame.game-header.title"),
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },
  computed: {
    // wordRank() {
    //   return this.word.qWord.know || 0;
    // }
  },
  watch: {
    currentData() {
      console.log("I AM HERE");
      this.lessonName = this.currentData.lesson.name;
    }
  },
  created() {
    this.arrowIconPath = getArrowIconPath(localStorage.getItem("srcDirection"));
    console.log(this.externalData);
  },
  methods: {
    prevChapter: function(event) {
      if (Object.keys(this.externalData).length) {
        this.$router.push({
          path: `/external-grammar/`
        });
      } else {
        this.$router.push({
          path: `/chapter/`
        });
      }
    }
  },
  components: {}
};
</script>

<style scoped>
.backarrowDiv {
  display: flex;
  width: 50px;
  height: 50px;
}
.arrow-svg-game {
  margin: auto;
  height: 30px;
  fill: var(--button-primary-text);
  aspect-ratio: 1/1;
}
</style>



// WEBPACK FOOTER //
// game-header.vue?564833a8